export default __webpack_public_path__ + "static/cafe_36081-ded755d2dac2678924ed6d95a45bf3ca.png";